'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.ContentModel = exports.ContentModels = exports.description = undefined;

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _contentmodel = require('./contentmodel');

var bypassAuthContentModels = _interopRequireWildcard(_contentmodel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// // in local context, style will be loaded via normal webpack require (direct insert into head)
// // in remote context, webpack will compile this as a string, and export as "stylesheet" from module
// import style from './style.css';

// basic auth functionality
var description = exports.description = "Bypass auth strategy.  This allows anonymous straight in.";
// export const stylesheet = style;
var ContentModels = exports.ContentModels = bypassAuthContentModels;
var ContentModel = exports.ContentModel = bypassAuthContentModels.default;
var Component = exports.Component = _component2.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(description, 'description', 'src/core_modules/bypass-auth-strategy/index.js');

  __REACT_HOT_LOADER__.register(ContentModels, 'ContentModels', 'src/core_modules/bypass-auth-strategy/index.js');

  __REACT_HOT_LOADER__.register(ContentModel, 'ContentModel', 'src/core_modules/bypass-auth-strategy/index.js');

  __REACT_HOT_LOADER__.register(Component, 'Component', 'src/core_modules/bypass-auth-strategy/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/bypass-auth-strategy/index.js
// module chunks = 0